// Libraries
import React from 'react'
import PropTypes from 'prop-types'
import { DatePicker } from 'antd'
import { Field } from 'formik'
// Styles
import { ErrorMessage } from '../styles'

const Datepicker = ({ name, label, style, ...props }) => {
  const onChangeUpdated = (form) => (props.onChange ? props.onChange : (value) => form.setFieldValue(name, value))
  return (
    <div style={style}>
      {label && <label htmlFor={name}>{label}</label>}
      <Field id={name} name={name} {...props}>
        {({ field, form }) => (
          <div>
            <DatePicker
              {...props}
              value={field.value}
              onBlur={() => form.setFieldTouched(name, true)}
              onChange={onChangeUpdated(form)}
            />
            <ErrorMessage name={name} component='div' className='error' />
          </div>
        )}
      </Field>
    </div>
  )
}

Datepicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
}

export default Datepicker
